import React from "react";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useAppContext } from "../../context";

export default function BrancheAddress({
    branches,
    isOpen,
}: {
    branches: any[];
    isOpen: boolean;
}) {
    const { setOpenPopUp, setShowPopUpCalculate, setCurrencySellRates, setCurrencyBuyRates, setCurrence, setBuyCurrencyInfo, setPopupContent } = useAppContext();

    const normalizeRate = (rate: number, multiplier?: number) => rate / (multiplier || 1);



const handleOpenCalculator = (branch: any) => {
        
    setShowPopUpCalculate(true);
    setOpenPopUp(true);

    // ===== Currency list =====
    const newCurrence = Array.from(
        new Set([branch.SourceISO, branch.TargetISO])
    );

    setCurrence(newCurrence);

    // ===== Rates =====
    const multiplier = branch.Multiplier || 1;

    const sellRates = {
        GEL_GEL: 1,
        [`${branch.SourceISO}_GEL`]: normalizeRate(Number(branch.SellRate), multiplier),
    };

    const buyRates = {
        GEL_GEL: 1,
        [`${branch.SourceISO}_GEL`]: normalizeRate(Number(branch.BuyRate), multiplier),
    };
    
    setCurrencySellRates(sellRates);
    setCurrencyBuyRates(buyRates);

    // ===== default selected currency =====
    setBuyCurrencyInfo(branch.SourceISO);
};

    return (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Box
                sx={{
                    px: { xs: 2, md: 6 },
                    py: 2,
                    background: "#F7F9FC",
                    borderBottom: "1px solid #e5e5e5",
                    borderRadius: { xs: "16px", md: 0 },
                }}
            >
                {branches?.map((b: any, i: number) => (
                    <Box
                        key={i}
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "5fr 3fr 1fr 40px" },
                            gap: 1.5,
                            py: 2,
                            borderBottom: "1px solid #e5e5e5",
                            "&:last-child": { borderBottom: "none" },
                        }}
                    >
                        {/* ===== ADDRESS ===== */}
                        <Typography
                            sx={{
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#27384E",
                                gridColumn: { xs: "1 / -1", md: "auto" },
                            }}
                        >
                            {b.descrip}
                        </Typography>

                        {/* ===== BUY / SELL / ICON ===== */}
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr 1fr 40px", md: "1fr 1fr 40px" },
                                alignItems: "center",
                                justifyItems: "center",
                                textAlign: "center",
                                gap: 1,
                                gridColumn: { xs: "1 / -1", md: "auto" },
                            }}
                        >
                            <Box>
                                <Typography fontSize={12} color="#7A8FA6">
                                    ყიდვა
                                </Typography>
                                <Typography fontWeight={700}>{b.BuyRate}</Typography>
                            </Box>

                            <Box>
                                <Typography fontSize={12} color="#7A8FA6">
                                    გაყიდვა
                                </Typography>
                                <Typography fontWeight={700}>{b.SellRate}</Typography>
                            </Box>

                            <IconButton
                                color="error"
                                onClick={() => {
                                    setPopupContent("Calculate");
                                    setOpenPopUp(true);
                                    handleOpenCalculator(b);
                                }}
                            >
                                <SwapHorizIcon />
                            </IconButton>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Collapse>
    );
}
